export const userQueryKeys = {
  all: ["user"],
  byPrincipalIds: (principalIds: string[]) => [...userQueryKeys.all, "byPrincipalIds", principalIds],
  byId: (id: string) => [...userQueryKeys.all, "id", id],
};
